export class ClsZonaDomicilioModel {
  public ZD_ID: number;
  public ZD_NEGO_ID: number;
  public ZD_PARAM_ID: number;
  public ZD_PARAM_DESCRIP: string;
  public ZD_VALOR: number;
  public ZD_ESTADO: string;
  public ZD_USU_ID: number;
}
